import {
  FilterProvider,
  Flex,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  ModalProvider,
  MultiFileUploadProvider,
  PageViewProvider,
  MediaDragAndDropProvider,
} from "dash-ui";

import { GetPropertyByIdQuery } from "gql/generated.graphql";

import MediaPageHeader from "./components/MediaPageHeader/MediaPageHeader";
import SetFolderNameModal from "./components/SetFolderNameModal/SetFolderNameModal";
import RemoveFolderModal from "./components/RemoveFolderModal/RemoveFolderModal";
import RemoveMediaFileModal from "./components/RemoveMediaFileModal/RemoveMediaFileModal";
import EditMediaFileModal from "./components/EditMediaFileModal/EditMediaFileModal";
import MoveFileToFolderModal from "./components/MoveFileToFolderModal/MoveFileToFolderModal";
import MediaFilesView from "./components/MediaFilesView/MediaFilesView";
import UploadMediaWithBrandingModal from "./components/UploadMediaWithBrandingModal/UploadMediaWithBrandingModal";
import UpdateMediaBrandingModal from "./components/UpdateMediaBrandingModal/UpdateMediaBrandingModal";

const PropertyMedia = ({
  property,
}: {
  property: GetPropertyByIdQuery["getPropertyById"];
}) => {
  return (
    <PaginationProvider>
      <SortProvider>
        <SearchProvider>
          <FilterProvider>
            <MultiFileUploadProvider>
              <PageViewProvider>
                <MediaDragAndDropProvider>
                  <Flex flexDirection="column">
                    <ModalProvider>
                      <>
                        <MediaPageHeader
                          propertyId={property._id}
                          property={property}
                        />
                        <MediaFilesView propertyId={property._id} />
                        <SetFolderNameModal propertyId={property._id} />
                        <RemoveFolderModal />
                        <RemoveMediaFileModal />
                        <EditMediaFileModal />
                        <MoveFileToFolderModal />
                        <UploadMediaWithBrandingModal
                          propertyId={property._id}
                        />
                        <UpdateMediaBrandingModal />
                      </>
                    </ModalProvider>
                  </Flex>
                </MediaDragAndDropProvider>
              </PageViewProvider>
            </MultiFileUploadProvider>
          </FilterProvider>
        </SearchProvider>
      </SortProvider>
    </PaginationProvider>
  );
};

export default PropertyMedia;
